import {
    CMSFilterCreateModel,
    CMSOperators,
} from '../../../../models/cms-placeholder.model';

export const getCmsAlreadyUsedOperators = (
    filterAttributes?: CMSFilterCreateModel[],
    inputRowData?: CMSFilterCreateModel,
): CMSOperators[] => {
    const chosenAttribute = filterAttributes?.filter(
        (attribute) =>
            attribute.cms_placeholder_id === inputRowData?.cms_placeholder_id,
    );
    return (
        chosenAttribute
            ?.map((attribute) => attribute.operator)
            .filter((value) => !!value) || []
    );
};
